var _templateObject;
function _taggedTemplateLiteral(strings, raw) { if (!raw) {
    raw = strings.slice(0);
} return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
import { Suspense, useRef } from 'react';
import { QueryClient, QueryClientProvider } from 'react-query';
import { ReactQueryDevtools } from 'react-query/devtools';
import { Provider } from 'react-redux';
import { Router } from 'react-router';
import { CompatRouter } from 'react-router-dom-v5-compat';
import { ThemeProvider as MuiThemeProvider } from '@material-ui/core/styles';
import { ToastProvider, createToastService, customMediaStylisPlugin } from '@nordlayer/rivendell-ui';
import '@nordlayer/rivendell-ui/lib/theme/base.css';
import '@nordlayer/rivendell-ui/lib/theme/design-tokens-legacy.css';
import { ReactAriaRouterProvider } from 'hooks/ReactAriaRouterProvider';
import { RegionProvider } from 'shared/components/RegionSwitcher/RegionProvider';
import styled, { StyleSheetManager, ThemeProvider } from 'styled-components';
import 'theme/design-tokens.css';
import { loadGorditaFont } from '@nord/typography';
import WithLoader from '@nordvpn/teams.core/lib/hocs/withLoader';
import Toast from '@nordvpn/teams.core/lib/molecules/Toast';
import TranslationDisabler from '@nordvpn/teams.core/lib/molecules/TranslationDisabler';
import ErrorBoundary from '@nordvpn/teams.core/lib/pages/ErrorBoundary';
import History from '@nordvpn/teams.core/lib/tools/history';
import { theme } from '@nordvpn/teams.ui/lib/theme';
import 'assets/scss/base.scss';
import 'assets/scss/overrides.scss';
import 'assets/scss/toastify-custom.scss';
import { Preloader } from 'components/organisms/Preloader';
import { BaseRouting } from 'routing/BaseRouting';
import { PreviousPageReactRouterListener } from 'routing/contexts';
import { configuredStore } from 'store/configuredStore';
import { shouldForwardProp } from 'utils/shouldForwardProp';
import { SENTRY_ENABLED } from 'settings';
import { FeatureFlagsProvider } from 'templates/FeatureFlagsProvider';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
loadGorditaFont();
var queryClient = new QueryClient();
var ToastContainer = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  /* Otherwise error notifications are behind modal windows */\n  z-index: 1000;\n"])));
var App = function App() {
    var storeRef = useRef(configuredStore());
    var toastService = createToastService();
    return /*#__PURE__*/ _jsx(ErrorBoundary, {
        logSentry: SENTRY_ENABLED,
        children: /*#__PURE__*/ _jsx(StyleSheetManager, {
            shouldForwardProp: shouldForwardProp,
            stylisPlugins: [customMediaStylisPlugin],
            children: /*#__PURE__*/ _jsxs(QueryClientProvider, {
                client: queryClient,
                children: [/*#__PURE__*/ _jsx(ReactQueryDevtools, {
                        position: "bottom-right"
                    }), /*#__PURE__*/ _jsxs(Provider, {
                        store: storeRef.current,
                        children: [/*#__PURE__*/ _jsx(TranslationDisabler, {}), /*#__PURE__*/ _jsx(Router, {
                                history: History,
                                children: /*#__PURE__*/ _jsx(CompatRouter, {
                                    children: /*#__PURE__*/ _jsx(ReactAriaRouterProvider, {
                                        children: /*#__PURE__*/ _jsx(FeatureFlagsProvider, {
                                            children: /*#__PURE__*/ _jsxs(RegionProvider, {
                                                children: [/*#__PURE__*/ _jsx(ToastContainer, {
                                                        className: "fixed left-0 top-0 w-full mainWrapper",
                                                        children: /*#__PURE__*/ _jsx(Toast, {})
                                                    }), /*#__PURE__*/ _jsx(ThemeProvider, {
                                                        theme: theme,
                                                        children: /*#__PURE__*/ _jsx(MuiThemeProvider, {
                                                            theme: theme,
                                                            children: /*#__PURE__*/ _jsx(PreviousPageReactRouterListener, {
                                                                children: /*#__PURE__*/ _jsx(Suspense, {
                                                                    fallback: /*#__PURE__*/ _jsx(WithLoader, {}),
                                                                    children: /*#__PURE__*/ _jsx(Preloader, {
                                                                        children: /*#__PURE__*/ _jsx(ToastProvider, {
                                                                            toastService: toastService,
                                                                            children: /*#__PURE__*/ _jsx(BaseRouting, {})
                                                                        })
                                                                    })
                                                                })
                                                            })
                                                        })
                                                    })]
                                            })
                                        })
                                    })
                                })
                            })]
                    })]
            })
        })
    });
};
export default App;
